import { ICON_FIELD, IMAGE_MOBILE, IMAGE_DESKTOP } from '../elements/assets'
import { LINK_TITLE, BUTTON_SETTINGS } from '../elements/link'

export const INDUSTRY_SHOWCASE_CAROUSEL = `
...on industryShowcaseCarousel_Entry {
  id
  typeHandle
  
  headingAdvanced { html }

  industryShowcaseMatrix {
    id
    title
    ${ ICON_FIELD }

    heading { html }
    description { html }

    ${ LINK_TITLE }
    ${ BUTTON_SETTINGS }

    ${ IMAGE_MOBILE }
    ${ IMAGE_DESKTOP }
  }
}
`